import { render } from "./dpp-bar.vue?vue&type=template&id=be32982a"
import script from "./dpp-bar.js?vue&type=script&lang=js"
export * from "./dpp-bar.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__